// extracted by mini-css-extract-plugin
module.exports = {"input":"FormLeft_input__1KvIB","label":"FormLeft_label__2BC7o"};